export default {
    
    show_raw_data_modal_title: "Sin procesar",
    show_raw_data_modal_cancel: "Cancelar",
    show_raw_data_modal_copy: "Copiar",
    show_raw_data_modal_copied: "Copiado!",
    
};